/* ============================================
   STILENZA — Collection Page
   AJAX filtering, sorting, load-more, quick-add
   ============================================ */

/* --- Observer cleanup on navigation --- */
const _collObservers = [];
window.addEventListener('pagehide', function() {
  _collObservers.forEach(function(o) { o.disconnect(); });
});

/* --- Color hex lookup for filter swatches --- */
const STILENZA_COLOR_HEX = {
  'black': '#000000', 'white': '#ffffff', 'navy': '#1b2a4a', 'red': '#c0392b',
  'blue': '#3b7dd8', 'green': '#4a7c59', 'pink': '#e8a0bf', 'beige': '#d4c5a9',
  'grey': '#8c8c8c', 'gray': '#8c8c8c', 'brown': '#6b4226', 'cream': '#f5f0e1',
  'khaki': '#b5a67d', 'burgundy': '#722f37', 'olive': '#6b6b3c', 'camel': '#c19a6b',
  'tan': '#d2b48c', 'coral': '#e87461', 'mustard': '#d4a017', 'lavender': '#b4a7d6',
  'teal': '#2c7873', 'charcoal': '#36454f', 'babyblue': '#89cff0', 'sage': '#9caf88',
  'rust': '#b7410e', 'mauve': '#b784a7', 'ivory': '#fffff0', 'taupe': '#8b8589',
  'wine': '#722f37', 'mint': '#98ff98', 'dustyrose': '#dcae96', 'sand': '#c2b280',
  'stone': '#928e85', 'nude': '#e3c9b8', 'lilac': '#c8a2c8', 'peach': '#ffcba4',
  'yellow': '#f0c040', 'orange': '#e07020', 'gold': '#c9a84c', 'silver': '#c0c0c0',
  'rose': '#c77986', 'plum': '#5c374c', 'denim': '#4a6fa5', 'indigo': '#3b3080',
  'terracotta': '#c45a3c', 'ecru': '#cdb891', 'oatmeal': '#d3c5a5', 'mocha': '#7b5b3a',
  'espresso': '#3c2415', 'cobalt': '#0047ab', 'seafoam': '#71cfc5', 'blush': '#de98ab',
  'slate': '#6e7a82', 'offwhite': '#faf8f0', 'off-white': '#faf8f0',
  'multi': 'conic-gradient(from 0deg, #e87461, #f0c040, #4a7c59, #3b7dd8, #b784a7, #e87461)',
  'multicolor': 'conic-gradient(from 0deg, #e87461, #f0c040, #4a7c59, #3b7dd8, #b784a7, #e87461)',
  'multicolour': 'conic-gradient(from 0deg, #e87461, #f0c040, #4a7c59, #3b7dd8, #b784a7, #e87461)'
};

const STILENZA_LIGHT_COLORS = ['white','cream','ivory','off-white','offwhite','beige','nude','ecru','oatmeal','sand'];

function stilenzaResolveColor(label) {
  const key = label.toLowerCase().replace(/\s+/g, '');
  const keySpaces = label.toLowerCase();
  const hex = STILENZA_COLOR_HEX[key] || STILENZA_COLOR_HEX[keySpaces];
  if (hex) return hex;
  // Substring fallback: "Light Blue" → try "blue", "Dark Green" → try "green"
  const parts = keySpaces.split(/\s+/);
  for (let i = parts.length - 1; i >= 0; i--) {
    if (STILENZA_COLOR_HEX[parts[i]]) return STILENZA_COLOR_HEX[parts[i]];
  }
  // Last resort: use as CSS color name
  return key;
}

function stilenzaApplyColorSwatches() {
  /* All swatches with data-color-label (color strip + mobile filter) */
  document.querySelectorAll('[data-color-label]').forEach(function(swatch) {
    const label = swatch.dataset.colorLabel;
    const key = label.toLowerCase().replace(/\s+/g, '');

    // Shopify geeft de hexwaarde van het filter mee. Die gaat vóór de naamtabel,
    // want die tabel is Engels: in het Japans heet geel イエロー en in het Frans
    // Jaune, en dan viel het bolletje terug op de naam als CSS-kleur — ongeldig,
    // dus kleurloos. De hex is in elke markt dezelfde.
    const hex = swatch.dataset.colorHex || stilenzaResolveColor(label);
    if (swatch.dataset.colorImg) {
      swatch.style.background = 'url(' + swatch.dataset.colorImg + ') center/cover';
    } else {
      swatch.style.background = hex;
    }

    // Lichte kleuren krijgen een randje, anders verdwijnt het bolletje op wit.
    // Op de helderheid van de hex toetsen in plaats van op de naam, want ook die
    // lijst was Engels.
    let licht = STILENZA_LIGHT_COLORS.indexOf(key) !== -1;
    const m = /^#([0-9a-f]{6})$/i.exec((swatch.dataset.colorHex || '').trim());
    if (m) {
      const n = parseInt(m[1], 16);
      const helderheid = (((n >> 16) & 255) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000;
      licht = helderheid > 225;
    }
    if (licht) swatch.setAttribute('data-needs-border', '');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', stilenzaApplyColorSwatches);
  document.addEventListener('DOMContentLoaded', stilenzaInitCardGalleries);
} else {
  stilenzaApplyColorSwatches();
  stilenzaInitCardGalleries();
}

/* --- Card Gallery: swipeable images + dot indicators --- */
function stilenzaInitCardGalleries(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-card-gallery]').forEach(function(wrapper) {
    const track = wrapper.querySelector('.stil-card__gallery-track');
    if (!track) return;

    const segs = Array.from(wrapper.querySelectorAll('.stil-card__progress-seg'));
    if (segs.length < 2) return;

    let _scrollTick = false;
    function updateProgress() {
      if (_scrollTick) return;
      _scrollTick = true;
      requestAnimationFrame(function() {
        _scrollTick = false;
        let index = Math.round(track.scrollLeft / track.clientWidth);
        index = Math.max(0, Math.min(index, segs.length - 1));
        segs.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
      });
    }

    // Update segments on scroll
    track.addEventListener('scroll', updateProgress, { passive: true });

    // Desktop mouse drag
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let dragged = false;

    track.addEventListener('mousedown', function(e) {
      isDown = true;
      dragged = false;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
    });
    window.addEventListener('mouseup', function() {
      if (isDown) {
        isDown = false;
        track.style.cursor = 'grab';
      }
    });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) dragged = true;
      track.scrollLeft = scrollLeft - walk;
    });

    // Prevent card <a> navigation on drag
    const cardLink = wrapper.closest('a');
    if (cardLink) {
      cardLink.addEventListener('click', function(e) {
        if (dragged) {
          e.preventDefault();
          dragged = false;
        }
      });
    }
  });
}

/* --- Facets Web Component --- */
class StilenzaFacets extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.debouncedOnSubmit = this.debounce(this.onSubmitHandler.bind(this), 250);

    const form = this.querySelector('#StilenzaFiltersForm');
    if (form) {
      form.addEventListener('input', this.debouncedOnSubmit);
    }

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.stil-coll__filter-group')) {
        document.querySelectorAll('.stil-coll__filter-group[open]').forEach(function (d) {
          d.removeAttribute('open');
        });
      }
    });
  }

  debounce(fn, wait) {
    let timer;
    return function () {
      const args = arguments;
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(context, args); }, wait);
    };
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(this.querySelector('#StilenzaFiltersForm'));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  renderPage(searchParams, pushState) {
    if (pushState === undefined) pushState = true;

    const grid = document.getElementById('StilenzaProductGrid');
    if (grid) grid.classList.add('stil-coll--loading');

    const section = document.getElementById('stilenza-collection-section');
    const sectionId = section ? section.dataset.sectionId : '';
    const url = window.location.pathname + '?section_id=' + sectionId + (searchParams ? '&' + searchParams : '');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        // Replace product grid
        const newGrid = parsed.getElementById('StilenzaProductGrid');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
          grid.classList.remove('stil-coll--loading');
        }

        // Replace filter bar (update counts + active states)
        const newFilterBar = parsed.querySelector('.stil-coll__filter-bar');
        const currentFilterBar = document.querySelector('.stil-coll__filter-bar');
        if (newFilterBar && currentFilterBar) {
          currentFilterBar.innerHTML = newFilterBar.innerHTML;
        }

        // Replace active filter chips
        const newActive = parsed.getElementById('StilenzaActiveFilters');
        const currentActive = document.getElementById('StilenzaActiveFilters');
        if (newActive && currentActive) {
          currentActive.innerHTML = newActive.innerHTML;
        }

        // Replace product count
        const newCount = parsed.getElementById('StilenzaProductCount');
        const currentCount = document.getElementById('StilenzaProductCount');
        if (newCount && currentCount) {
          currentCount.innerHTML = newCount.innerHTML;
        }

        // Replace load-more
        const newLoadMore = parsed.getElementById('StilenzaLoadMore');
        const currentLoadMore = document.getElementById('StilenzaLoadMore');
        if (newLoadMore) {
          if (currentLoadMore) {
            currentLoadMore.innerHTML = newLoadMore.innerHTML;
          } else {
            grid.parentNode.appendChild(newLoadMore);
          }
        } else if (currentLoadMore) {
          currentLoadMore.remove();
        }

        // Replace mobile controls active count
        const newMobileControls = parsed.querySelector('.stil-coll__mobile-controls');
        const currentMobileControls = document.querySelector('.stil-coll__mobile-controls');
        if (newMobileControls && currentMobileControls) {
          currentMobileControls.innerHTML = newMobileControls.innerHTML;
        }

        // Replace desktop color strip
        const newColorStrip = parsed.getElementById('StilenzaColorStrip');
        const currentColorStrip = document.getElementById('StilenzaColorStrip');
        if (newColorStrip && currentColorStrip) {
          currentColorStrip.innerHTML = newColorStrip.innerHTML;
        }

        // Replace mobile color strip
        const newMobileStrip = parsed.getElementById('StilenzaColorStripMobile');
        const currentMobileStrip = document.getElementById('StilenzaColorStripMobile');
        if (newMobileStrip && currentMobileStrip) {
          currentMobileStrip.innerHTML = newMobileStrip.innerHTML;
        }

        // Re-apply color hex backgrounds
        stilenzaApplyColorSwatches();

        // Init card galleries
        stilenzaInitCardGalleries(grid);

        // Animate new cards
        stilenzaAnimateCards();

        // Sync wishlist state on new cards
        document.dispatchEvent(new CustomEvent('stilenza:products-updated'));
      })
      .catch(function() {
        if (grid) grid.classList.remove('stil-coll--loading');
      });

    if (pushState) {
      history.pushState({ searchParams: searchParams }, '', window.location.pathname + (searchParams ? '?' + searchParams : ''));
    }
  }
}

if (typeof customElements !== 'undefined') {
  customElements.define('stilenza-facets', StilenzaFacets);
}

/* --- History popstate --- */
window.addEventListener('popstate', function (event) {
  const searchParams = event.state ? event.state.searchParams : '';
  const facets = document.querySelector('stilenza-facets');
  if (facets) facets.renderPage(searchParams || '', false);
});

/* --- Sort select (both desktop & mobile) --- */
document.addEventListener('change', function (e) {
  const select = e.target.closest('[data-sort-select]');
  if (!select) return;

  // Update the visible label in the custom sort wrapper
  const label = select.closest('.stil-coll__sort-wrap') && select.closest('.stil-coll__sort-wrap').querySelector('.stil-coll__sort-label');
  if (label) {
    const chosen = select.options[select.selectedIndex];
    if (chosen) label.textContent = chosen.text;
  }

  const facets = document.querySelector('stilenza-facets');
  if (facets) {
    // Get current filter params + add sort
    const form = document.getElementById('StilenzaFiltersForm');
    const formData = form ? new FormData(form) : new FormData();
    formData.set('sort_by', select.value);
    const searchParams = new URLSearchParams(formData).toString();
    facets.renderPage(searchParams);
  } else {
    // No facets component — full page reload
    window.location.href = window.location.pathname + '?sort_by=' + select.value;
  }
});

/* --- Active filter chip removal --- */
document.addEventListener('click', function (e) {
  const removeBtn = e.target.closest('.js-filter-remove');
  if (!removeBtn) return;

  e.preventDefault();
  const url = removeBtn.href;
  let searchParams = '';
  if (url && url.indexOf('?') !== -1) {
    searchParams = url.slice(url.indexOf('?') + 1);
  }

  const facets = document.querySelector('stilenza-facets');
  if (facets) facets.renderPage(searchParams);
});

/* --- Mobile filter drawer --- */
document.addEventListener('click', function (e) {
  // Open drawer
  if (e.target.closest('[data-open-filters]')) {
    const drawer = document.getElementById('StilenzaFilterDrawer');
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    return;
  }

  // Close drawer
  if (e.target.closest('[data-close-filters]')) {
    const drawer = document.getElementById('StilenzaFilterDrawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    return;
  }

  // Apply filters from mobile drawer
  if (e.target.closest('[data-apply-filters]')) {
    const mobileForm = document.getElementById('StilenzaFiltersFormMobile');
    if (mobileForm) {
      const formData = new FormData(mobileForm);
      // Include sort
      const sortSelect = document.querySelector('.stil-coll__ctrl-sort');
      if (sortSelect) formData.set('sort_by', sortSelect.value);

      const searchParams = new URLSearchParams(formData).toString();
      const facets = document.querySelector('stilenza-facets');
      if (facets) facets.renderPage(searchParams);
    }

    // Close drawer
    const drawer = document.getElementById('StilenzaFilterDrawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    return;
  }
});

/* --- Load More --- */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.stil-coll__load-more-btn');
  if (!btn) return;

  const nextUrl = btn.dataset.nextUrl;
  if (!nextUrl) return;

  var _gridEl = document.getElementById('StilenzaProductGrid');
  var _collLabels = _gridEl ? _gridEl.dataset : {};
  btn.textContent = (_collLabels.labelLoading || 'Loading...');
  btn.disabled = true;

  const section = document.getElementById('stilenza-collection-section');
  const sectionId = section ? section.dataset.sectionId : '';
  const separator = nextUrl.indexOf('?') !== -1 ? '&' : '?';

  fetch(nextUrl + separator + 'section_id=' + sectionId)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      // Get new product cards
      const newGrid = parsed.getElementById('StilenzaProductGrid');
      const grid = document.getElementById('StilenzaProductGrid');
      if (newGrid && grid) {
        const newCards = newGrid.children;
        const fragment = document.createDocumentFragment();
        const cardElements = [];
        while (newCards.length > 0) {
          cardElements.push(newCards[0]);
          fragment.appendChild(newCards[0]);
        }
        grid.appendChild(fragment);

        // Animate new cards with CSS
        cardElements.forEach(function(el, i) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(20px)';
          el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
          setTimeout(function() {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }, i * 60);
        });

        // Init galleries on newly added cards
        cardElements.forEach(function(el) {
          stilenzaInitCardGalleries(el);
        });
      }

      // Update load-more button
      const newLoadMore = parsed.getElementById('StilenzaLoadMore');
      const currentLoadMore = document.getElementById('StilenzaLoadMore');
      if (newLoadMore) {
        currentLoadMore.innerHTML = newLoadMore.innerHTML;
      } else if (currentLoadMore) {
        currentLoadMore.remove();
      }
    });
});

/* --- Quick-add size buttons --- */
document.addEventListener('click', function (e) {
  const sizeBtn = e.target.closest('.stil-card__size-btn');
  if (!sizeBtn || sizeBtn.disabled) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = sizeBtn.dataset.variantId;
  if (!variantId) return;

  const originalText = sizeBtn.textContent;
  sizeBtn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      sizeBtn.textContent = '\u2713';

      // Try to open cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.open) cartDrawer.open();

      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Update cart count badge (shared utility from theme.liquid)
      if (window.__stilUpdateCartBadge) window.__stilUpdateCartBadge();

      setTimeout(function () { sizeBtn.textContent = originalText; }, 1500);
    })
    .catch(function () {
      sizeBtn.textContent = originalText;
    });
});

/* --- Color swatch image swap --- */
document.addEventListener('mouseover', function (e) {
  const swatch = e.target.closest('.stil-card__swatch[data-swatch-img]');
  if (!swatch) return;

  const card = swatch.closest('.stil-card');
  if (!card) return;

  const primaryImg = card.querySelector('.stil-card__img--primary');
  if (primaryImg) {
    if (!primaryImg.dataset.originalSrc) {
      primaryImg.dataset.originalSrc = primaryImg.src;
    }
    primaryImg.src = swatch.dataset.swatchImg;
  }
});

document.addEventListener('mouseout', function (e) {
  const swatch = e.target.closest('.stil-card__swatch[data-swatch-img]');
  if (!swatch) return;

  const card = swatch.closest('.stil-card');
  if (!card) return;

  const primaryImg = card.querySelector('.stil-card__img--primary');
  if (primaryImg && primaryImg.dataset.originalSrc) {
    primaryImg.src = primaryImg.dataset.originalSrc;
  }
});

/* --- Mobile color strip filter submission --- */
document.addEventListener('input', function(e) {
  const checkbox = e.target;
  if (!checkbox.id || !checkbox.id.startsWith('CBar-')) return;

  /* Sync with mobile drawer checkbox */
  const mobileDrawerId = checkbox.id.replace('CBar-', 'MFilter-');
  const mobileDrawerCheckbox = document.getElementById(mobileDrawerId);
  if (mobileDrawerCheckbox) mobileDrawerCheckbox.checked = checkbox.checked;

  /* Build filter params from mobile form + trigger AJAX */
  const mobileForm = document.getElementById('StilenzaFiltersFormMobile');
  if (mobileForm) {
    const formData = new FormData(mobileForm);
    const sortSelect = document.querySelector('.stil-coll__ctrl-sort');
    if (sortSelect) formData.set('sort_by', sortSelect.value);
    const searchParams = new URLSearchParams(formData).toString();
    const facets = document.querySelector('stilenza-facets');
    if (facets) facets.renderPage(searchParams);
  }
});

/* --- CSS card animation helper --- */
function stilenzaAnimateCards() {
  const cards = document.querySelectorAll('#StilenzaProductGrid .stil-card');
  cards.forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    setTimeout(function() {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, i * 80);
  });
}

/* ============================================
   QUICK VIEW — Cinematic modal with morph
   ============================================ */
(function() {
  const qv = document.getElementById('StilenzaQuickView');
  if (!qv) return;

  const panel = document.getElementById('StilenzaQvPanel');
  const morph = document.getElementById('StilenzaQvMorph');
  const galleryMain = document.getElementById('StilenzaQvGalleryMain');
  const thumbsWrap = document.getElementById('StilenzaQvThumbs');
  const infoPanel = document.getElementById('StilenzaQvInfo');
  let productData = null;
  let selectedOptions = {};
  let activeGalleryIndex = 0;

  /* --- Open Quick View --- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.stil-card__quickview');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    const card = btn.closest('.stil-card');
    const cardImg = card ? card.querySelector('.stil-card__img--primary') : null;

    openQuickView(handle, cardImg);
  });

  function openQuickView(handle, sourceImg) {
    // Reset
    galleryMain.innerHTML = '';
    thumbsWrap.innerHTML = '';
    infoPanel.innerHTML = '<div class="stil-qv__loading"><div class="stil-qv__spinner"></div></div>';
    productData = null;
    selectedOptions = {};
    activeGalleryIndex = 0;

    // Morph animation from card image
    if (sourceImg) {
      const rect = sourceImg.getBoundingClientRect();
      morph.style.display = 'block';
      morph.style.top = rect.top + 'px';
      morph.style.left = rect.left + 'px';
      morph.style.width = rect.width + 'px';
      morph.style.height = rect.height + 'px';
      morph.style.borderRadius = '0px';
      morph.style.opacity = '1';
      morph.innerHTML = '<img src="' + sourceImg.src + '" alt="">';

      // Show modal container
      qv.classList.add('is-open');
      qv.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Animate morph to gallery position
      requestAnimationFrame(function() {
        const panelRect = panel.getBoundingClientRect();
        let targetW = panelRect.width / 2;
        let targetH = panelRect.height;
        let targetX = panelRect.left;
        let targetY = panelRect.top;

        // On mobile, gallery takes full width but top half
        if (window.innerWidth < 750) {
          targetW = panelRect.width;
          targetH = Math.min(panelRect.height * 0.45, 400);
          targetX = panelRect.left;
          targetY = panelRect.top;
        }

        morph.style.transition = 'all 0.45s cubic-bezier(0.16, 1, 0.3, 1)';
        morph.style.top = targetY + 'px';
        morph.style.left = targetX + 'px';
        morph.style.width = targetW + 'px';
        morph.style.height = targetH + 'px';
        morph.style.borderRadius = window.innerWidth >= 750 ? '4px 0 0 4px' : '0';

        setTimeout(function() {
          morph.style.opacity = '0';
          morph.style.transition = 'opacity 0.2s ease';
          setTimeout(function() {
            morph.style.display = 'none';
            morph.style.transition = '';
          }, 200);
        }, 400);
      });
    } else {
      qv.classList.add('is-open');
      qv.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    // Fetch product data
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'products/' + handle + '.js')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        productData = data;
        renderQuickView(data);
      })
      .catch(function() {
        var _gEl = document.getElementById('StilenzaProductGrid');
        var _cLabels = _gEl ? _gEl.dataset : {};
        infoPanel.innerHTML = '<p style="padding:20px;color:#999;">' + (_cLabels.labelLoadError || 'Could not load product.') + '</p>';
      });
  }

  /* --- Close Quick View --- */
  function closeQuickView() {
    qv.classList.remove('is-open');
    qv.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    morph.style.display = 'none';
  }

  qv.querySelector('.stil-qv__close').addEventListener('click', closeQuickView);
  qv.querySelector('.stil-qv__backdrop').addEventListener('click', closeQuickView);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && qv.classList.contains('is-open')) closeQuickView();
  });

  /* --- Render product data into modal --- */
  function renderQuickView(data) {
    // Gallery
    const images = data.images || [];
    galleryMain.innerHTML = '';
    thumbsWrap.innerHTML = '';

    images.forEach(function(src, i) {
      const img = document.createElement('img');
      img.src = getSizedUrl(src, '800x');
      img.alt = data.title;
      img.loading = i === 0 ? 'eager' : 'lazy';
      if (i === 0) img.classList.add('is-active');
      galleryMain.appendChild(img);

      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'stil-qv__gallery-thumb' + (i === 0 ? ' is-active' : '');
      thumb.innerHTML = '<img src="' + getSizedUrl(src, '120x') + '" alt="">';
      thumb.setAttribute('aria-label', 'View image ' + (i + 1));
      thumb.dataset.index = i;
      thumbsWrap.appendChild(thumb);
    });

    // Info panel
    let html = '';

    // Vendor
    if (data.vendor) {
      html += '<p class="stil-qv__vendor">' + escapeHtml(data.vendor) + '</p>';
    }

    // Title
    html += '<h2 class="stil-qv__title">' + escapeHtml(data.title) + '</h2>';

    // Price
    const currentVariant = data.variants[0];
    html += buildPriceHtml(currentVariant);

    // Options — data.options from .js endpoint are objects: {name, position, values}
    data.options.forEach(function(option, optIndex) {
      const optionName = option.name;
      const values = option.values;
      const nameLower = optionName.toLowerCase();
      const isColor = nameLower === 'color' || nameLower === 'colour';
      const isSize = nameLower === 'size' || nameLower === 'taille' || nameLower === 'maat';

      selectedOptions[optionName] = currentVariant.options[optIndex];

      html += '<div class="stil-qv__option-group">';
      html += '<span class="stil-qv__option-label">' + escapeHtml(optionName) + ': <span class="js-qv-option-value" data-option="' + escapeHtml(optionName) + '">' + escapeHtml(selectedOptions[optionName]) + '</span></span>';

      if (isColor) {
        html += '<div class="stil-qv__colors">';
        values.forEach(function(val) {
          const variantImg = getColorVariantImage(data, optIndex, val);
          const active = val === selectedOptions[optionName] ? ' is-active' : '';
          const inner = variantImg
            ? '<img src="' + getSizedUrl(variantImg, '80x') + '" alt="' + escapeHtml(val) + '">'
            : '';
          const bgStyle = !variantImg ? ' style="background:' + escapeHtml(val.toLowerCase().replace(/\s/g,'')) + ';"' : '';
          html += '<button type="button" class="stil-qv__color-swatch' + active + '" data-option="' + escapeHtml(optionName) + '" data-value="' + escapeHtml(val) + '"' + bgStyle + ' title="' + escapeHtml(val) + '">' + inner + '</button>';
        });
        html += '</div>';
      } else if (isSize) {
        html += '<div class="stil-qv__sizes">';
        values.forEach(function(val) {
          const available = isValueAvailable(data, optIndex, val);
          const active = val === selectedOptions[optionName] ? ' is-active' : '';
          const soldOut = !available ? ' is-sold-out' : '';
          html += '<button type="button" class="stil-qv__size-btn' + active + soldOut + '" data-option="' + escapeHtml(optionName) + '" data-value="' + escapeHtml(val) + '"' + (!available ? ' disabled' : '') + '>' + escapeHtml(val) + '</button>';
        });
        html += '</div>';
      } else {
        html += '<div class="stil-qv__sizes">';
        values.forEach(function(val) {
          const active = val === selectedOptions[optionName] ? ' is-active' : '';
          html += '<button type="button" class="stil-qv__size-btn' + active + '" data-option="' + escapeHtml(optionName) + '" data-value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</button>';
        });
        html += '</div>';
      }

      html += '</div>';
    });

    // ATC button
    const atcDisabled = !currentVariant.available ? ' disabled' : '';
    const atcText = currentVariant.available ? 'ADD TO BAG' : 'SOLD OUT';
    html += '<button type="button" class="stil-qv__atc" id="StilenzaQvAtc"' + atcDisabled + '>' + atcText + '</button>';

    // View full details link
    html += '<a href="' + data.url + '" class="stil-qv__view-full">View Full Details</a>';

    infoPanel.innerHTML = html;
  }

  /* --- Thumb click --- */
  thumbsWrap.addEventListener('click', function(e) {
    const thumb = e.target.closest('.stil-qv__gallery-thumb');
    if (!thumb) return;
    const idx = parseInt(thumb.dataset.index);
    setQvGalleryIndex(idx);
  });

  function setQvGalleryIndex(idx) {
    activeGalleryIndex = idx;
    const imgs = galleryMain.querySelectorAll('img');
    const thumbs = thumbsWrap.querySelectorAll('.stil-qv__gallery-thumb');
    imgs.forEach(function(img, i) { img.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
  }

  /* --- Option selection (delegated) --- */
  infoPanel.addEventListener('click', function(e) {
    const swatch = e.target.closest('.stil-qv__color-swatch, .stil-qv__size-btn');
    if (!swatch || swatch.disabled) return;

    const optionName = swatch.dataset.option;
    const value = swatch.dataset.value;
    selectedOptions[optionName] = value;

    // Update active states
    const siblings = swatch.parentNode.querySelectorAll('[data-option="' + optionName + '"]');
    siblings.forEach(function(s) { s.classList.toggle('is-active', s.dataset.value === value); });

    // Update label
    const label = infoPanel.querySelector('.js-qv-option-value[data-option="' + optionName + '"]');
    if (label) label.textContent = value;

    // Find matching variant
    const variant = findVariant();
    if (variant) {
      // Update price
      const priceRow = infoPanel.querySelector('.stil-qv__price-row');
      if (priceRow) {
        const temp = document.createElement('div');
        temp.innerHTML = buildPriceHtml(variant);
        priceRow.replaceWith(temp.firstChild);
      }

      // Update ATC
      const atcBtn = document.getElementById('StilenzaQvAtc');
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
      }

      // If color changed, scroll gallery to matching image
      if (swatch.classList.contains('stil-qv__color-swatch') && variant.featured_image) {
        const targetSrc = variant.featured_image.src;
        const imgs = galleryMain.querySelectorAll('img');
        imgs.forEach(function(img, i) {
          if (img.src.indexOf(getImageFilename(targetSrc)) !== -1) {
            setQvGalleryIndex(i);
          }
        });
      }
    }
  });

  /* --- Add to Cart --- */
  infoPanel.addEventListener('click', function(e) {
    const atcBtn = e.target.closest('.stil-qv__atc');
    if (!atcBtn || atcBtn.disabled) return;

    const variant = findVariant();
    if (!variant || !variant.available) return;

    var _gAdd = document.getElementById('StilenzaProductGrid');
    atcBtn.textContent = ((_gAdd && _gAdd.dataset.labelAdding) || 'ADDING...');
    atcBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    })
      .then(function(res) { return res.json(); })
      .then(function() {
        var _gEl2 = document.getElementById('StilenzaProductGrid');
        var _cLabels2 = _gEl2 ? _gEl2.dataset : {};
        atcBtn.textContent = (_cLabels2.labelAdded || 'ADDED \u2713');

        // Refresh cart
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.__stilUpdateCartBadge) window.__stilUpdateCartBadge();

        // Open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.open) cartDrawer.open();

        setTimeout(function() {
          closeQuickView();
        }, 800);
      })
      .catch(function() {
        atcBtn.textContent = 'ADD TO BAG';
        atcBtn.disabled = false;
      });
  });

  /* --- Helper functions --- */
  function findVariant() {
    if (!productData) return null;
    return productData.variants.find(function(v) {
      return productData.options.every(function(opt, i) {
        return v.options[i] === selectedOptions[opt.name];
      });
    }) || null;
  }

  function isValueAvailable(data, optIndex, value) {
    return data.variants.some(function(v) {
      return v.options[optIndex] === value && v.available;
    });
  }

  function getColorVariantImage(data, optIndex, colorValue) {
    for (let i = 0; i < data.variants.length; i++) {
      if (data.variants[i].options[optIndex] === colorValue && data.variants[i].featured_image) {
        return data.variants[i].featured_image.src;
      }
    }
    return null;
  }

  function getSizedUrl(url, size) {
    // Shopify image URL sizing: insert _800x before extension
    return url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  function getImageFilename(url) {
    return url.split('/').pop().split('?')[0].replace(/_\d+x\d*/, '').replace(/_\d+x/, '');
  }

  function buildPriceHtml(variant) {
    let html = '<div class="stil-qv__price-row">';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<span class="stil-qv__price notranslate" translate="no">' + formatMoney(variant.price) + '</span>';
      html += '<span class="stil-qv__compare-price notranslate" translate="no">' + formatMoney(variant.compare_at_price) + '</span>';
      const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      // Schrijfwijze uit de locales — "-23%" in Europa en de VS, "23%OFF" in Japan.
      const _qvGrid = document.getElementById('StilenzaProductGrid');
      const sjabloon = (_qvGrid && _qvGrid.dataset.labelDiscountBadge) || '-__PCT__%';
      html += '<span class="stil-qv__discount">' + sjabloon.replace('__PCT__', pct) + '</span>';
    } else {
      html += '<span class="stil-qv__price notranslate" translate="no">' + formatMoney(variant.price) + '</span>';
    }
    html += '</div>';
    return html;
  }

  // Shared utility from theme.liquid, with local fallback
  const formatMoney = window.__stilFormatMoney || function(cents) {
    // Noodgeval: theme.liquid definieert window.__stilFormatMoney normaal altijd.
    return ((Number(cents) || 0) / 100).toFixed(2);
  };

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

/* --- Card swatch → swap gallery image --- */
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.stil-card__swatch');
  if (!swatch) return;

  // Prevent navigating to product page
  e.preventDefault();
  e.stopPropagation();

  const imgUrl = swatch.dataset.swatchImg;
  if (!imgUrl) return;

  const card = swatch.closest('.stil-card');
  if (!card) return;

  // Update first image in gallery track
  const firstImg = card.querySelector('.stil-card__gallery-track .stil-card__img');
  if (firstImg) {
    firstImg.src = imgUrl;
    firstImg.srcset = imgUrl + ' 800w';
    // Reset scroll to first image
    const track = card.querySelector('.stil-card__gallery-track');
    if (track) track.scrollLeft = 0;
  }

  // Update active state on swatches
  card.querySelectorAll('.stil-card__swatch').forEach(function (s) {
    s.classList.remove('is-active');
  });
  swatch.classList.add('is-active');
});

/* Het hartje op de kaart is verhuisd naar assets/stilenza-wishlist.js.
   Dit bestand laadt alleen op de collectiepagina, terwijl de kaart op zes
   plekken wordt gerenderd — op de homepage deed het hartje dus niets. */

})();
